const { locales } = require("../../../locales")
const { objetEstDefini } = require("./utils")

class PrestationsTirage {
  constructor(image, langue) {
    this.tarifs = image[langue].tirage.tarifs
    this.prixMinimal = image[langue].tirage.prix_minimal
    this.langue = langue
    this.dimensions = this.obtenirDimensions()
    this.finitions = this.obtenirFinitions()
  }

  obtenirDimensions() {
    let dimensions = []

    for (let tarif of this.tarifs) {
      const id = tarif.split(":")[0]
      const largeurHauteur = this.extraireLargeurEtHauteur(id)
      const surface = largeurHauteur.largeur * largeurHauteur.hauteur
      const texte = this.obtenirTexteDimension(id)
      dimensions.push({
        code: id,
        texte: texte,
        surface: surface,
      })
    }

    return dimensions.sort(this.comparerSurfaces)
  }

  extraireLargeurEtHauteur(chaineDimensions) {
    const largeur = chaineDimensions.split("x")[0]
    const hauteur = chaineDimensions.split("x")[1]

    return { largeur: largeur, hauteur: hauteur }
  }

  obtenirTexteDimension(idDimension) {
    const dimensions = this.extraireLargeurEtHauteur(idDimension)
    return `${dimensions.largeur} x ${dimensions.hauteur} cm`
  }

  comparerSurfaces(dimensions1, dimensions2) {
    if (dimensions1.surface > dimensions2.surface) return 1
    else if (dimensions1.surface < dimensions2.surface) return -1
    else return 0
  }

  obtenirFinitions() {
    let resultat = {}

    for (let tarif of this.tarifs) {
      let dimension = tarif.split(":")[0]
      let donneesBrutesFinitionsDimension = tarif.split(":")[1].split("|")

      let finitionsPourUneDimension = []

      for (let i = 0; i < donneesBrutesFinitionsDimension.length; i++) {
        const prix = donneesBrutesFinitionsDimension[i]
          .match(/\[(.+?)\]/g)[0]
          .replace(/\[|\]/g, "")

        if (!objetEstDefini(prix))
          throw new Error(
            `Le prix n'a pas été correctement renseigné. Il doit être entre crochets. Vérifiez le fichier yaml source.`
          )

        const libelleFinition = donneesBrutesFinitionsDimension[i].split("[")[0]
        const differenceAvecPrixMinimal = prix - this.prixMinimal

        const id = libelleFinition + " " + this.obtenirTexteDimension(dimension)
        const texte =
          libelleFinition + " " + this.obtenirTextePrix(prix, this.langue)

        finitionsPourUneDimension.push({
          code: id,
          texte: texte,
          prix: prix,
          differenceAvecPrixMinimal: differenceAvecPrixMinimal,
          finition: libelleFinition,
        })
      }
      resultat[dimension] = finitionsPourUneDimension
    }
    return resultat
  }

  rechercherFinitionsPourUneDimension(idDimension) {
    return this.finitions[idDimension]
  }

  obtenirTextePrix(prix, langue) {
    return "(" + locales[langue].boutique.prix.replace("{0}", prix) + ")"
  }
}

function rechercherFinition(collectionFinitions, idFinition) {
  for (let dimension in collectionFinitions) {
    let finitions = collectionFinitions[dimension]
    for (let finition of finitions) {
      if (finition.code === idFinition) return finition
    }
  }
  throw new Error(`La finition id=${idFinition} n'a pas été trouvée.`)
}

module.exports = { PrestationsTirage, rechercherFinition }
